import BillingInfo from "./billingInfo";

export default BillingInfo;
